module.exports = __webpack_public_path__ + "menu_2_pc.b8540a16.png";